import type { ReactNode } from 'react';

import { PermissionGuard, usePermissions } from '@alamo/auth';

/** Read and decision capabilities both authorize opening the existing analysis detail. */
export function AnalystDetailAccess({ children }: { children: ReactNode }) {
  const { hasPermission } = usePermissions();
  return (
    <PermissionGuard
      resource="proposals"
      action={hasPermission('proposals', 'analyze') ? 'analyze' : 'analysis_read'}
    >
      {children}
    </PermissionGuard>
  );
}
